import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AUTOMATIONS_LIST_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { get_automations_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { useOrgProject } from '@/context/OrgProjectContext/useOrgProject.ts';
import { Automations } from '@/types/automations.ts';

const useRetrieveAutomations = (): UseQueryResult<Automations, AxiosError> => {
  const apiClient = useApiClient();
  const { projectId } = useOrgProject();

  return useQuery({
    queryKey: AUTOMATIONS_LIST_KEY(projectId),
    queryFn: async () => {
      const results: Automations['results'] = [];
      let page: number | null = 1;
      let firstPage: Automations | undefined;

      while (page !== null) {
        const response = await apiClient.get(get_automations_url(projectId), {
          params: { page },
        });
        const pageData = response.data as Automations;
        firstPage ??= pageData;
        results.push(...pageData.results);
        page = pageData.next?.page ?? null;
      }

      return {
        ...firstPage!,
        results,
        next: null,
        previous: null,
      };
    },
    enabled: !!projectId, // Prevents running query if project is undefined/null
  });
};

export default useRetrieveAutomations;
